<template>
  <div class="container-fluid mtb15 no-fluid">
    <div class="row sm-gutters">
      <div v-if="1200 < getWindowsWidth" class="col-sm-12 col-md-2">
        <AppMenu></AppMenu>
      </div>
      <div v-if="'InstrumentTypeBreakdown' === currentVuewName" class="col-sm-12" :class="{ 'col-md-10': 1200 < getWindowsWidth }">
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <button class="btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" @click.prevent="goBack()">&larr;</button>
          </div>
          <div class="col-sm-11 text-left wallet-detail-title">
            <h5>{{ labels.positions }} - {{ groupLabel }}</h5>
          </div>
        </div>
        <div class="card mb-3">
          <div class="card-body">
            <h5 class="text-center">{{ groupLabel }}</h5>
            <table class="table">
              <tbody>
                <tr>
                  <td>{{ labels.balance }}</td>
                  <td class="equity_align_right_heavy">{{ formatPrice(groupValue, getCurrency).replace(' ', '&nbsp;') }}</td>
                </tr>
                <tr>
                  <td>{{ labels.instruments }}</td>
                  <td class="equity_align_right_heavy">{{ parseNumber(groupStocks.length, 0) }}</td>
                </tr>
                <tr>
                  <td>{{ labels.return }}</td>
                  <td class="equity_align_right_heavy" :class="returnClass">
                    {{ formattedReturn }}
                    <img
                      v-if="returnValue !== 0"
                      class="quote-change-icon"
                      :src="returnValue > 0 ? quoteUpIcon : quoteDownIcon"
                      alt=""
                    >
                  </td>
                </tr>
                <tr>
                  <td>%{{ labels.positionsBalance }}</td>
                  <td class="equity_align_right_heavy">
                    <span class="progress-meter-value">
                      <meter :value="positionsBalancePercent" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(positionsBalancePercent) }}%</span>
                    </span>
                  </td>
                </tr>
                <tr>
                  <td>%{{ labels.totalBalance }}</td>
                  <td class="equity_align_right_heavy">
                    <span class="progress-meter-value">
                      <meter :value="totalBalancePercent" min="0" max="100"></meter>
                      <span class="progress-percent">{{ parseNumber(totalBalancePercent) }}%</span>
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <WalletExchangePositionsList
          :stocks="groupStocks"
          :window-width="getWindowsWidth"
          :user-language="getUserLanguage"
          :labels="labels"
          :stock-type-resolver="getStockType"
          :positions-amount-resolver="getPositionsAmount"
          :trade-purchase-price-resolver="getTradePurchasePrice"
          :trade-market-price-resolver="getTradeMarketPrice"
          :percent-diff-resolver="getPercentDiff"
          :format-price="formatPrice"
          :parse-number="parseNumber"
          @open-trades="openTradesList"
          @open-details="openInstrumentDetails"
        />
      </div>
      <div v-if="'ActivityDetails' === currentVuewName" class="col-sm-12 col-md-10">
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <button class="btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" @click.prevent="currentVuewName = 'InstrumentTypeBreakdown'">&larr;</button>
          </div>
          <div class="col-sm-11 text-left wallet-detail-title">
            <h5>{{ labels.positions }} - {{ groupLabel }} - {{ selectedItem?.sc }} - {{ activityTabLabel }}</h5>
          </div>
        </div>
        <div class="row sm-gutters">
          <div class="col-sm-12 col-md-2">
            <ul class="nav nav-tabs nav-pills settings-nav position-activity-tabs mb-3">
              <li class="nav-item" v-for="tab in activityTabs" :key="tab.key">
                <button
                  type="button"
                  class="nav-link"
                  :class="{ active: activityTab === tab.key }"
                  @click.prevent="activityTab = tab.key"
                >{{ tab.label }}</button>
              </li>
            </ul>
          </div>
          <div class="col-sm-12 col-md-10">
            <WalletExchangeInstrumentDetails
              v-if="'Information' === activityTab && !selectedInstrumentIsOff"
              :item="selectedItem"
              :window-width="getWindowsWidth"
              :user-language="getUserLanguage"
              :exchange-name="groupLabel"
              :labels="labels"
              :all-exchanges-equities-value="allEquitiesValue"
              :stock-type-resolver="getStockType"
              :positions-amount-resolver="getPositionsAmount"
              :trade-purchase-price-resolver="getTradePurchasePrice"
              :trade-market-price-resolver="getTradeMarketPrice"
              :percent-diff-resolver="getPercentDiff"
              :format-price="formatPrice"
              :parse-number="parseNumber"
            />
            <div v-if="'Information' === activityTab && selectedInstrumentIsOff" class="instrument-not-traded-message">
              {{ labels.instrumentNoLongerTraded }}
            </div>
            <WalletExchangeTradesList
              v-if="'Trades' === activityTab"
              :trades="getFilteredTrades"
              :trade-list-orders="tradeListOrders"
              :window-width="getWindowsWidth"
              :user-language="getUserLanguage"
              :labels="labels"
              :date-resolver="getDate"
              :purchase-type-resolver="getPurchaseType"
              :order-type-resolver="getOrderType"
              :order-status-resolver="getOrderStatus"
              :trade-total-amount-resolver="getTradeTotalAmount"
              :capitalize-first-letter="capitalizeFirstLetter"
              :format-price="formatPrice"
              :parse-number="parseNumber"
              @open-trade-details="openTradeDetails"
            />
            <div v-if="'Transfers' === activityTab && !transfersLoaded" class="trade-details-loading">
              <Preloader />
            </div>
            <WalletExchangeTransfersList
              v-if="'Transfers' === activityTab && transfersLoaded"
              :transfers="getFilteredTransfers"
              :window-width="getWindowsWidth"
              :user-language="getUserLanguage"
              :labels="labels"
              :date-resolver="getDate"
              :transfer-type-resolver="getTransferType"
              :capitalize-first-letter="capitalizeFirstLetter"
              :format-price="formatPrice"
              :parse-number="parseNumber"
              @open-transfer-details="openTransferDetails"
            />
          </div>
        </div>
      </div>
      <div v-if="'TradeDetails' === currentVuewName" class="col-sm-12 col-md-10">
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <button class="btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" @click.prevent="currentVuewName = 'ActivityDetails'; activityTab = 'Trades'">&larr;</button>
          </div>
          <div class="col-sm-11 text-left wallet-detail-title">
            <h5>{{ labels.positions }} - {{ groupLabel }} - {{ selectedItem?.sc }} - {{ labels.trades }} - #{{ trade?.oid }}</h5>
          </div>
        </div>
        <div v-if="tradeDetailsLoading" class="trade-details-loading">
          <Preloader />
        </div>
        <WalletExchangeTradeDetails
          v-else
          :trade="trade"
          :trade-list-orders="tradeListOrders"
          :window-width="getWindowsWidth"
          :user-language="getUserLanguage"
          :labels="labels"
          :date-resolver="getDate"
          :order-type-resolver="getOrderType"
          :trade-total-amount-resolver="getTradeTotalAmount"
          :format-price="formatPrice"
        />
      </div>
      <div v-if="'TransferDetails' === currentVuewName" class="col-sm-12 col-md-10">
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <button class="btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" @click.prevent="currentVuewName = 'ActivityDetails'; activityTab = 'Transfers'">&larr;</button>
          </div>
          <div class="col-sm-11 text-left wallet-detail-title">
            <h5>{{ labels.positions }} - {{ groupLabel }} - {{ selectedItem?.sc }} - {{ labels.transfers }}</h5>
          </div>
        </div>
        <WalletExchangeTransferDetails
          :transfer="transfer"
          :window-width="getWindowsWidth"
          :user-language="getUserLanguage"
          :labels="labels"
          :date-resolver="getDate"
          :transfer-type-resolver="getTransferType"
          :stock-type-resolver="getStockType"
          :format-price="formatPrice"
          :parse-number="parseNumber"
        />
      </div>
      <div v-if="'InstrumentDetails' === currentVuewName" class="col-sm-12 col-md-10">
        <div class="row align-items-center wallet-detail-header">
          <div class="col-sm-1 wallet-detail-back">
            <button class="btn btn-outline-secondary btn-light mb-2" :class="{ 'xsmall-font-size': 1200 > getWindowsWidth }" @click.prevent="currentVuewName = 'InstrumentTypeBreakdown'">&larr;</button>
          </div>
          <div class="col-sm-11 text-left wallet-detail-title">
            <h5>{{ labels.positions }} - {{ groupLabel }} - {{ selectedItem?.sc }} - {{ labels.information }}</h5>
          </div>
        </div>
        <WalletExchangeInstrumentDetails
          v-if="!selectedInstrumentIsOff"
          :item="selectedItem"
          :window-width="getWindowsWidth"
          :user-language="getUserLanguage"
          :exchange-name="groupLabel"
          :labels="labels"
          :all-exchanges-equities-value="allEquitiesValue"
          :stock-type-resolver="getStockType"
          :positions-amount-resolver="getPositionsAmount"
          :trade-purchase-price-resolver="getTradePurchasePrice"
          :trade-market-price-resolver="getTradeMarketPrice"
          :percent-diff-resolver="getPercentDiff"
          :format-price="formatPrice"
          :parse-number="parseNumber"
        />
        <div v-else class="instrument-not-traded-message">
          {{ labels.instrumentNoLongerTraded }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AppMenu from "@/components/ui/AppMenu.vue";
import Preloader from "@/components/ui/Preloader.vue";
import UiUtils from "@/assets/js/ui_utils.js";
import I18n from "@/lang/i18n.js";
import WalletExchangeInstrumentDetails from "@/features/wallet/components/WalletExchangeInstrumentDetails.vue";
import WalletExchangePositionsList from "@/features/wallet/components/WalletExchangePositionsList.vue";
import WalletExchangeTradeDetails from "@/features/wallet/components/WalletExchangeTradeDetails.vue";
import WalletExchangeTradesList from "@/features/wallet/components/WalletExchangeTradesList.vue";
import WalletExchangeTransferDetails from "@/features/wallet/components/WalletExchangeTransferDetails.vue";
import WalletExchangeTransfersList from "@/features/wallet/components/WalletExchangeTransfersList.vue";
import { getStockTypeLabel } from "@/features/stocks/stock-type-labels";
import { getOrderActionLabel, getOrderStatusLabel, getPurchaseTypeLabel, getTransferTypeLabel } from "@/features/wallet/wallet-label-formatters";
import { getTotalAssetsValue, getTotalEquitiesValue, getStocksByPositionGroup } from "@/features/wallet/wallet-portfolio-metrics";
import { getTradeOrderById, preloadTradeOrders as preloadExchangeTradeOrders } from "@/features/wallet/wallet-exchange-trades";
import { fetchTrades, fetchTransfers } from "@/features/wallet/wallet-api";
import { sortTransfersBySelection } from "@/features/wallet/wallet-list-utils";
import quoteDownIcon from "@/assets/images/Quote-Down.svg";
import quoteUpIcon from "@/assets/images/Quote-Up.svg";

export default {
  components: {
    AppMenu,
    Preloader,
    WalletExchangeInstrumentDetails,
    WalletExchangePositionsList,
    WalletExchangeTradeDetails,
    WalletExchangeTradesList,
    WalletExchangeTransferDetails,
    WalletExchangeTransfersList
  },
  props: {
    groupKey: { type: String, required: true }
  },
  data() {
    return {
      selectedItem: null,
      currentVuewName: "InstrumentTypeBreakdown",
      trade: null,
      transfer: null,
      activityTab: "Trades",
      transfers: [],
      transfersLoaded: false,
      transfersRequest: null,
      tradesLoaded: false,
      tradesRequest: null,
      tradeDetailsLoading: false,
      tradeListOrders: [],
      orderRequests: {}
    };
  },
  computed: {
    getWindowsWidth() {
      return this.$store.getters["getAppWindowWidth"] || window.innerWidth;
    },
    getUserLanguage() {
      return this.$store.getters["getNonLoggedInLanguage"]?.toUpperCase() || "EN";
    },
    getCurrency() {
      return this.$store.getters["getCurrency"].toUpperCase();
    },
    labels() {
      return {
        amount: this.t("amountLabel"),
        averagePrice: this.t("averagePriceLabel"),
        balance: this.t("balanceLabel"),
        baseCurrency: this.t("baseCurrencyLabel"),
        bonds: this.t("bondsLabel"),
        buy: this.t("buyLabel"),
        cancelled: this.t("cancelledLabel"),
        cfd: this.t("cfdLabel"),
        code: this.t("codeLabel"),
        compInstruments: this.t("compInstrumentsLabel"),
        currency: this.t("currencyLabel"),
        equities: this.t("equitiesLabel"),
        exchange: this.t("exchangeLabel"),
        faceValue: this.t("faceValueLabel"),
        fee: this.t("feeLabel"),
        filled: this.t("filledLabel"),
        funds: this.t("fundsLabel"),
        information: this.t("informationLabel"),
        incoming: this.t("incomingLabel"),
        instrumentType: this.t("instrumentTypeLabel"),
        instrumentNoLongerTraded: this.t("instrumentNoLongerTradedMessage"),
        instruments: this.t("myNumberOfInstrumentsLabel"),
        limit: this.t("limitLabel"),
        margin: this.t("marginLabel"),
        market: this.t("marketLabel"),
        marketPrice: this.t("marketPriceLabel"),
        myPositions: this.t("myPositionsLabel"),
        name: this.t("nameLabel"),
        netting: this.t("nettingLabel"),
        numberOfShares: this.t("numberOfSharesLabel"),
        orderId: this.t("orderLabel"),
        orderType: this.t("orderTypeLabel"),
        outgoing: this.t("outgoingLabel"),
        placed: this.t("placedLabel"),
        position: this.t("positionLabel"),
        positions: this.t("positionsLabel"),
        positionsBalance: this.t("positionsBalanceLabel"),
        price: this.t("priceLabel"),
        processing: this.t("processingLabel"),
        purchasePrice: this.t("purchasePriceLabel"),
        quantity: this.t("quantityLabel"),
        reits: this.t("reitsLabel"),
        repo: this.t("repoLabel"),
        return: this.t("returnLabel"),
        rights: this.t("rightsLabel"),
        sell: this.t("sellLabel"),
        stockCode: this.t("codeLabel"),
        stockName: this.t("nameLabel"),
        stocksAndEtfs: this.t("stocksAndEtfsLabel"),
        segment: this.t("segmentLabel"),
        status: this.t("statusLabel"),
        timestamp: this.t("timestampLabel"),
        totalAmount: this.t("totalAmountLabel"),
        totalBalance: this.t("totalBalanceLabel"),
        tradeId: this.t("tradeIdLabel"),
        trades: this.t("tradesLabel"),
        transfers: this.t("transfersMenuItem"),
        type: this.t("typeLabel"),
        value: this.t("valueLabel"),
        other: this.t("othersLabel")
      };
    },
    groupLabel() {
      const labels = {
        stocksAndEtfs: this.t("stocksAndEtfsLabel"),
        bonds: this.t("bondsLabel"),
        reits: this.t("reitsLabel"),
        other: this.t("othersLabel")
      };
      return labels[this.groupKey] || this.groupKey;
    },
    groupStocks() {
      return getStocksByPositionGroup(this.$store.getters["getWallet"], this.groupKey);
    },
    groupValue() {
      const wallet = { ...this.$store.getters["getWallet"], s: this.groupStocks };
      return getTotalEquitiesValue({
        stocks: this.$store.getters["getStocks"],
        indexedStocks: this.$store.getters["getIndexedStocks"],
        wallet,
        currency: this.getCurrency
      });
    },
    groupAvgValue() {
      return this.groupStocks.reduce((total, position) => {
        const wallet = { ...this.$store.getters["getWallet"], s: [position] };
        return total + UiUtils.extractExchangeEquitiesAverageValue(
          this.$store.getters["getStocks"],
          this.$store.getters["getIndexedStocks"],
          position.ex,
          this.getCurrency,
          wallet
        );
      }, 0);
    },
    returnValue() {
      return parseFloat(this.groupValue) - parseFloat(this.groupAvgValue);
    },
    quoteDownIcon() {
      return quoteDownIcon;
    },
    quoteUpIcon() {
      return quoteUpIcon;
    },
    returnPercent() {
      return 0 === parseFloat(this.groupAvgValue)
        ? 0
        : this.returnValue / parseFloat(this.groupAvgValue) * 100;
    },
    returnClass() {
      return {
        greenColor: 0 < this.returnValue,
        redColor: 0 > this.returnValue
      };
    },
    formattedReturn() {
      if (0 === parseFloat(this.groupAvgValue)) {
        return `${this.parseNumber(0)} (${this.parseNumber(0)}%)`;
      }

      const prefix = 0 < this.returnValue ? "+" : "";
      const percentPrefix = 0 < this.returnPercent ? "+" : "";
      return `${prefix}${this.parseNumber(this.returnValue)} (${percentPrefix}${this.parseNumber(this.returnPercent)}%)`;
    },
    allEquitiesValue() {
      return getTotalEquitiesValue({
        stocks: this.$store.getters["getStocks"],
        indexedStocks: this.$store.getters["getIndexedStocks"],
        wallet: this.$store.getters["getWallet"],
        currency: this.getCurrency
      });
    },
    totalAssetsValue() {
      return getTotalAssetsValue({
        wallet: this.$store.getters["getWallet"],
        currency: this.getCurrency
      });
    },
    totalBalance() {
      return parseFloat(this.allEquitiesValue) + parseFloat(this.totalAssetsValue);
    },
    positionsBalancePercent() {
      return this.clampPercent(0 === parseFloat(this.allEquitiesValue) ? 0 : this.groupValue / this.allEquitiesValue * 100);
    },
    totalBalancePercent() {
      return this.clampPercent(0 === parseFloat(this.totalBalance) ? 0 : this.groupValue / this.totalBalance * 100);
    },
    getFilteredTrades() {
      const selected = this.selectedItem;
      if (!selected?.t?.length) {
        return [];
      }
      return this.uniqueBy(
        selected.t
          .filter(trade => "" !== trade?.oid?.toString())
          .map(trade => this.withSelectedInstrumentData(trade, selected)),
        trade => [trade.oid, trade.ts, trade.qty, trade.sp, trade.pt, trade.tt].join("|")
      );
    },
    getFilteredTransfers() {
      const selected = this.selectedItem;
      const selectedStockCode = selected?.sc?.toString().toLowerCase();
      const selectedExchange = selected?.ex?.toString().toLowerCase();
      const fetchedTransfers = this.transfers.filter(item => {
        const transferStockCode = item?.sc?.toString().toLowerCase();
        const transferExchange = item?.xc?.toString().toLowerCase() || item?.ex?.toString().toLowerCase();
        return selectedStockCode === transferStockCode
          && (!selectedExchange || selectedExchange === transferExchange);
      }).map(item => ({
        ...item,
        cc: item.cc ?? selected?.cc,
        xc: item.xc ?? item.ex ?? selected?.ex,
        sgm: item.sgm ?? item.segment ?? selected?.sgm,
        nEN: item.nEN ?? selected?.nEN,
        nBG: item.nBG ?? selected?.nBG,
        stid: item.stid ?? selected?.stid
      }));
      return sortTransfersBySelection(this.uniqueBy(fetchedTransfers, transfer => [
        transfer.ts,
        transfer.qty,
        transfer.sp,
        transfer.pt,
        transfer.tt,
        transfer.sc,
        transfer.xc
      ].join("|")), 1);
    },
    activityTabs() {
      return [
        { key: "Information", label: this.labels.information },
        { key: "Trades", label: this.labels.trades },
        { key: "Transfers", label: this.labels.transfers }
      ];
    },
    activityTabLabel() {
      return this.activityTabs.find(tab => tab.key === this.activityTab)?.label || "";
    },
    selectedInstrumentIsOff() {
      const selected = this.selectedItem;
      if (!selected) {
        return false;
      }

      const selectedCode = selected.sc?.toString().toUpperCase();
      const selectedExchange = (selected.xc ?? selected.ex)?.toString().toUpperCase();
      const isMatchingInstrument = trade => {
        const tradeCode = trade?.sc?.toString().toUpperCase();
        const tradeExchange = (trade?.xc ?? trade?.ex)?.toString().toUpperCase();
        return selectedCode === tradeCode && (!selectedExchange || selectedExchange === tradeExchange);
      };

      return selected.off === true
        || (selected.t || []).some(trade => trade?.off === true)
        || (this.$store.getters["wallet/trades"] || []).some(trade => trade?.off === true && isMatchingInstrument(trade));
    }
  },
  watch: {
    getFilteredTrades(trades) {
      this.preloadTradeOrders(trades);
    }
  },
  methods: {
    clampPercent(value) {
      const percent = parseFloat(value);
      return Number.isFinite(percent) ? Math.min(Math.max(percent, 0), 100) : 0;
    },
    t(key, ...args) {
      return I18n.t(key, this.getUserLanguage, ...args);
    },
    formatPrice(val, curr, autoDigits = 2) {
      return UiUtils.formatPrice(val, curr, this.getUserLanguage, autoDigits);
    },
    parseNumber(num, afterDot = 2) {
      return UiUtils.formatNumber(num, afterDot);
    },
    capitalizeFirstLetter(string) {
      return string ? string.charAt(0).toUpperCase() + string.slice(1).toLowerCase() : "";
    },
    getStockType(typeId) {
      return getStockTypeLabel(typeId, this.labels);
    },
    getDate(unix) {
      return UiUtils.parseUnixTime(unix);
    },
    getOrderType(ot) {
      return getOrderActionLabel(ot, this.labels);
    },
    getPurchaseType(type) {
      return getPurchaseTypeLabel(type, this.labels);
    },
    getTransferType(type) {
      return getTransferTypeLabel(type, this.labels);
    },
    getOrderStatus(order) {
      return getOrderStatusLabel(order, this.labels);
    },
    async getOrderById(orderId) {
      return getTradeOrderById({
        orderId,
        orders: this.tradeListOrders,
        requests: this.orderRequests,
        userType: this.$store.getters["getUserType"],
        user: this.$store.getters["getUser"]
      });
    },
    preloadTradeOrders(trades) {
      preloadExchangeTradeOrders({
        trades,
        orders: this.tradeListOrders,
        requests: this.orderRequests,
        userType: this.$store.getters["getUserType"],
        user: this.$store.getters["getUser"]
      });
    },
    goBack() {
      this.$router.push({
        name: "Wallet",
        query: {
          latestActiveMenuSelection: "Equities",
          positionsBreakdownTab: "InstrumentType"
        }
      });
    },
    async ensureTransfersLoaded() {
      if (this.transfersLoaded || this.transfersRequest) {
        return this.transfersRequest;
      }
      if (0 === parseInt(this.$store.getters["getUserType"])) {
        this.transfersLoaded = true;
        return null;
      }

      const user = this.$store.getters["getUser"];
      const today = new Date().toISOString().slice(0, 10);
      this.transfersRequest = fetchTransfers(this.$store.getters["getUserType"], user, "1970-01-01", today)
        .then(res => {
          if (0 === res?.data?.ec) {
            this.transfers = Array.isArray(res.data.stocks) ? res.data.stocks : [];
          }
          this.transfersLoaded = true;
        })
        .catch(err => {
          console.error(err);
          this.transfersLoaded = true;
        })
        .finally(() => {
          this.transfersRequest = null;
        });
      return this.transfersRequest;
    },
    async ensureTradesLoaded() {
      if (this.tradesLoaded || this.tradesRequest) {
        return this.tradesRequest;
      }

      const user = this.$store.getters["getUser"];
      const today = new Date().toISOString().slice(0, 10);
      this.tradesRequest = fetchTrades(this.$store.getters["getUserType"], user, "1970-01-01", today)
        .then(res => {
          if (0 === res?.data?.ec) {
            this.$store.commit("wallet/setTrades", Array.isArray(res.data.stocks) ? res.data.stocks : []);
          }
          this.tradesLoaded = true;
        })
        .catch(err => {
          console.error(err);
          this.tradesLoaded = true;
        })
        .finally(() => {
          this.tradesRequest = null;
        });
      return this.tradesRequest;
    },
    openTradesList(stock) {
      this.selectedItem = stock;
      this.activityTab = "Information";
      this.currentVuewName = "ActivityDetails";
      this.$nextTick(() => this.preloadTradeOrders(this.getFilteredTrades));
      this.ensureTradesLoaded();
      this.ensureTransfersLoaded();
    },
    openInstrumentDetails(stock) {
      this.selectedItem = stock;
      this.currentVuewName = "InstrumentDetails";
    },
    async openTradeDetails(transaction) {
      this.currentVuewName = "TradeDetails";
      this.tradeDetailsLoading = true;
      try {
        await this.ensureTradesLoaded();
        this.trade = this.enrichTradeFromStore(transaction);
        await this.getOrderById(this.trade?.oid);
      } finally {
        this.tradeDetailsLoading = false;
      }
    },
    openTransferDetails(transaction) {
      this.transfer = transaction;
      this.currentVuewName = "TransferDetails";
    },
    withSelectedInstrumentData(item, selected) {
      const storedTrade = item?.oid
        ? this.$store.getters["wallet/tradeById"]?.(item.oid.toString())
        : null;
      return {
        ...item,
        ...(storedTrade || {}),
        sc: item.sc ?? selected?.sc ?? storedTrade?.sc,
        cc: item.cc ?? selected?.cc ?? storedTrade?.cc,
        xc: item.xc ?? item.ex ?? selected?.ex ?? storedTrade?.xc,
        sgm: item.sgm ?? item.segment ?? selected?.sgm ?? storedTrade?.sgm,
        nEN: item.nEN ?? selected?.nEN ?? storedTrade?.nEN,
        nBG: item.nBG ?? selected?.nBG ?? storedTrade?.nBG,
        stid: item.stid ?? selected?.stid ?? storedTrade?.stid
      };
    },
    uniqueBy(items, keyResolver) {
      const seen = new Set();
      return items.filter(item => {
        const key = keyResolver(item);
        if (seen.has(key)) {
          return false;
        }
        seen.add(key);
        return true;
      });
    },
    enrichTradeFromStore(transaction) {
      const orderId = transaction?.oid?.toString();
      if (!orderId) {
        return transaction;
      }

      const storedTrade = this.$store.getters["wallet/tradeById"]?.(orderId);
      return storedTrade
        ? {
          ...transaction,
          ...storedTrade
        }
        : transaction;
    },
    getPercentDiff(marketPrice, avgPrice) {
      const diff = parseFloat(marketPrice) - parseFloat(avgPrice);
      return parseFloat(diff) / parseFloat(avgPrice) * 100;
    },
    getTradePurchasePrice(item) {
      return UiUtils.getTradePurchasePrice(this.$store.getters["getStocks"], this.$store.getters["getIndexedStocks"], item);
    },
    getTradeMarketPrice(item) {
      return UiUtils.getTradeMarketPrice(this.$store.getters["getStocks"], this.$store.getters["getIndexedStocks"], item);
    },
    getTradeTotalAmount(item) {
      return UiUtils.getTradeTotalAmountValue(this.$store.getters["getStocks"], this.$store.getters["getIndexedStocks"], item);
    },
    getPositionsAmount(item) {
      return UiUtils.getPositionsAmount(this.$store.getters["getStocks"], this.$store.getters["getIndexedStocks"], item);
    }
  }
};
</script>

<style scoped>
.card-body > .table td,
.card-body > .table th {
  font-size: 1rem !important;
}

.card-body > .table td.equity_align_right_heavy {
  font-weight: bold;
}

.wallet-detail-header {
  flex-wrap: nowrap;
}

.wallet-detail-back {
  flex: 0 0 auto;
  width: auto;
}

.wallet-detail-title {
  flex: 1 1 auto;
  width: auto;
}

.wallet-detail-title h5,
.wallet-detail-title h6 {
  margin-bottom: 0.5rem;
}

.xsmall-font-size {
  font-size: x-small;
}

.equity_align_right_heavy {
  text-align: right;
}

.progress-meter-value {
  align-items: center;
  display: inline-flex;
  gap: 0.25rem;
  white-space: nowrap;
}

.progress-percent {
  display: inline-block;
  min-width: 3.75rem;
  text-align: right;
}

.greenColor {
  color: #189e18;
}

.redColor {
  color: #ff0000;
}

.quote-change-icon {
  height: 12px;
  margin-left: 0.15rem;
  vertical-align: middle;
  width: 12px;
}

.position-activity-tabs {
  box-shadow: 0 0 15px #00000012;
  display: block;
  padding: 0.5rem;
}

.position-activity-tabs .nav-link {
  border: 0;
  border-radius: 0.25rem;
  color: #000b3c;
  font-weight: 600;
  margin-bottom: 0.25rem;
  text-align: left;
  width: 100%;
}

.position-activity-tabs .nav-link.active {
  background-color: #0d6efd;
  color: #fff;
}

.trade-details-loading {
  align-items: center;
  display: flex;
  justify-content: center;
  min-height: calc(100vh - 8rem);
  width: 100%;
}

.trade-details-loading :deep(.hollow-dots-spinner) {
  transform: scale(2);
}

.instrument-not-traded-message {
  font-size: 1rem;
  padding: 1rem;
}
</style>
